var _path, _path2, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.662,7.067h14.676v11.17c0,1.73-1.405,3.135-3.135,3.135H7.797c-1.73,0-3.135-1.405-3.135-3.135V7.067h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.728,2.628h12.545c1.265,0,2.291,1.027,2.291,2.291v2.148H3.436v-2.148c0-1.265,1.027-2.291,2.291-2.291Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.777,
    y1: 11.667,
    x2: 9.777,
    y2: 16.846
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14.223,
    y1: 11.667,
    x2: 14.223,
    y2: 16.846
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.cbf9501b9165e133b1ef82fe91db4c5b.svg";
export { ForwardRef as ReactComponent };